import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './dialog.component';
import { InsertionDirective } from './insertion.directive';
import { UploadPanelComponent } from 'src/app/document-management/components/upload-panel/upload-panel.component';
import { NewpersonFormComponent } from 'src/app/lem/pages/person/component/newperson-form/newperson-form.component';
import { InserimentoSocietaComponent } from 'src/app/lem/pages/amministrazione/pages/components/inserimento-societa/inserimento-societa-form.component';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { FormModalComponent } from './components/form-modal/form-modal.component';
import { DynamicFormModule } from '../dynamic-form/dynamic-form.module';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import {
  DocumentAssModalComponent
} from '../../../document-management/components/modals/document-ass-modal/document-ass-modal.component';

import { ModalMetadataComponent } from 'src/app/document-management/components/document-actions-card/modal-metadata/modal-metadata/modal-metadata.component';
import {
  CreazionePraticaStepperComponent
} from "../../../pratica/components/wizard-creazione/components/creazione-pratica-stepper/creazione-pratica-stepper.component";
import { ModalDepartmentFormComponent } from 'src/app/lem/pages/dipartimenti/components/modal-department-form/modal-department-form.component';
import { ModalRoleComponent } from 'src/app/lem/pages/dipartimenti/components/modal-role/modal-role.component';
import { ModalMemberComponent } from 'src/app/lem/pages/dipartimenti/components/modal-member/modal-member.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogConfig } from './dialog-config';
import { FocusTrapDirective } from 'src/app/common/directives/modal-accessibility.directive';



@NgModule({
  imports: [
    CommonModule,
    DynamicFormModule,
    ReactiveFormsModule],
  declarations: [DialogComponent, InsertionDirective, FormModalComponent, PdfViewerComponent, FocusTrapDirective],
  providers: [DialogConfig],
  entryComponents: [
    DialogComponent,
    UploadPanelComponent,
    NewpersonFormComponent,
    InserimentoSocietaComponent,
    ModalDepartmentFormComponent,
    ModalRoleComponent,
    ModalMemberComponent,
    ConfirmModalComponent,
    FormModalComponent,
    PdfViewerComponent,
    DocumentAssModalComponent,
    CreazionePraticaStepperComponent,
    ModalMetadataComponent,
  ]
})
export class DialogModule {}
